import { Injectable } from '@angular/core';
import {Analytics, logEvent} from '@angular/fire/analytics';

export enum AnalyticsEvent {
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
  ACCOUNT_CREATE = 'account_create',
  LOGIN = 'login',
  LOGOUT = 'logout',
  VIEW = 'view',
  APPOINTMENT_CREATE = 'appointment_create',
  APPOINTMENT_UPDATE = 'appointment_update',
  APPOINTMENT_DELETE = 'appointment_delete',
  APPOINTMENT_CANCEL = 'appointment_cancel',
  APPOINTMENT_CONFIRM = 'appointment_confirm',
  APPOINTMENT_OPEN_MODAL = 'appointment_open_modal',
  CLIENT_CREATE = 'client_create',
  CLIENT_UPDATE = 'client_update',
  CLIENT_DELETE = 'client_delete',
  CLIENT_OPEN_MODAL = 'client_open_modal',
  PAYMENT_CREATE = 'payment_create',
  PAYMENT_UPDATE = 'payment_update',
  PAYMENT_DELETE = 'payment_delete',

}

export function AnalyticsPageViewTracker(name?: string) {
  return function (constructor: any) {
      const old = constructor.prototype.ionViewWillEnter;
      constructor.prototype.ionViewWillEnter = function () {
          try {
              AnalyticsService.instance?.view(name);
          } catch (e) {
              console.error(e);
          }
          if (old) {
              old.apply(this, arguments);
          }
      };
  };
}

export function AnalyticsComponentViewTracker(name?: string) {
  return function (constructor: any) {
      const old = constructor.prototype.ionViewWillEnter;
      constructor.prototype.ngOnInit = function () {
          try {
              AnalyticsService.instance?.view(name);
          } catch (e) {
              console.error(e);
          }
          if (old) {
              old.apply(this, arguments);
          }
      };
  };
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  static instance: AnalyticsService;

  constructor(private analytics: Analytics) { 
    AnalyticsService.instance = this;
  }

  subscribe(plan: any) {
    logEvent(this.analytics, AnalyticsEvent.SUBSCRIBE, { ...plan });
  }

  unsubscribe(plan: any) {
    logEvent(this.analytics, AnalyticsEvent.UNSUBSCRIBE, { ...plan });
  }

  login() {
    logEvent(this.analytics, AnalyticsEvent.LOGIN);
  }

  logout() {
    logEvent(this.analytics, AnalyticsEvent.LOGOUT);
  }

  register() {
    logEvent(this.analytics, AnalyticsEvent.ACCOUNT_CREATE);
  }

  view(page_location?: string) {
    if (!page_location) {
      page_location =  window.location.origin + "/" + window.location.pathname.split('/').splice(1,2).join('/');
    }
    logEvent(this.analytics, AnalyticsEvent.VIEW, { page_location });
  }

  appointmentCreate(date: number, length: number) {
    const dateObj = new Date(date);
    const dateStr = dateObj.toLocaleDateString();
    logEvent(this.analytics, AnalyticsEvent.APPOINTMENT_CREATE, { 
      date: dateStr,
      day: dateObj.getDay(),
      month: dateObj.getMonth(),
      hour: dateObj.getHours(),
      length
    });
  }

  appointmentUpdate(date: number, length: number) {
    const dateObj = new Date(date);
    const dateStr = dateObj.toLocaleDateString();
    logEvent(this.analytics, AnalyticsEvent.APPOINTMENT_UPDATE, { 
      date: dateStr,
      day: dateObj.getDay(),
      month: dateObj.getMonth(),
      hour: dateObj.getHours(),
      length
    });
  }

  appointmentDelete(date: number, length: number) {
    const dateObj = new Date(date);
    const dateStr = dateObj.toLocaleDateString();
    logEvent(this.analytics, AnalyticsEvent.APPOINTMENT_DELETE, { 
      date: dateStr,
      day: dateObj.getDay(),
      month: dateObj.getMonth(),
      hour: dateObj.getHours(),
      length
    });
  }

  openAppointmentModal(action: 'create' | 'update') {

    logEvent(this.analytics, AnalyticsEvent.APPOINTMENT_OPEN_MODAL, { 
      action
    });
  }
  openClientModal(action: 'create' | 'update') {

    logEvent(this.analytics, AnalyticsEvent.CLIENT_OPEN_MODAL, { 
      action
    });
  }
}
